import React, { useState, useEffect } from 'react'
import add from '../../../../assets/images/add.png'
import { useHistory } from 'react-router-dom';
import $ from 'jquery';
import Api from "../../../../apis/apis";
import Notifications from "../../../../notifications/notifications";



function Trends() {

    let history = useHistory();


    let [trends,setTrends]=useState(null);

    useEffect(async () => {

        let res=await Api.allTrends();
        if (res.status == '200')
        {
            setTrends(res.data);
        }

        //initialize datatable
        $(document).ready(function () {
            setTimeout(function () {
                $('#example').DataTable();
            }, 500);
        });
    }, [])


    async function Delete(id) {
        let data = {
            id: id
        }

        let res = await Api.deleteTrend(data);
        console.log(res);

        if (res.status == '200') {
            await Notifications.successMsg(res.message);
            await refreshRecord();
        }
    }

    async function refreshRecord() {
        let res=await Api.allTrends();
        if (res.status == '200')
        {
            setTrends(res.data);
        }
    }




    return (
        <>
            <div className='driver-head'>
                <h3 className='dashboard-head-title'>Property Trends</h3>
                <div>
                    <div className='nav-buttons'>
                        <button onClick={() => history.push('/add-trend')} style={{ background: '#FF7B00', marginRight: '15px' }}><img src={add} alt="" />  Add Trend</button>
                    </div>
                </div>
            </div>
            <div className='dashboard-table-wrapper_ p-3' >

                <table id="example" className="table table-hover table-bordered" style={{ overFlow: "auto" }}>
                    <thead>
                    <tr>
                        <th>Id</th>
                        <th>Name</th>
                        <th>Year 1</th>
                        <th>Year 2</th>
                        <th>Year 3</th>
                        <th>Year 4</th>
                        <th>Year 5</th>
                        <th>Price 1</th>
                        <th>Price 2</th>
                        <th>Price 3</th>
                        <th>Price 4</th>
                        <th>Price 5</th>
                        <th>Action</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        trends?.map((itm,i)=>(
                            <tr>
                                <td>{itm.id}</td>
                                <td>{itm.name}</td>
                                <td>{itm.year1}</td>
                                <td>{itm.year2}</td>
                                <td>{itm.year3}</td>
                                <td>{itm.year4}</td>
                                <td>{itm.year5}</td>
                                <td>{itm.price1}</td>
                                <td>{itm.price2}</td>
                                <td>{itm.price3}</td>
                                <td>{itm.price4}</td>
                                <td>{itm.price5}</td>
                                <td><i onClick={async ()=>{await Delete(itm.id)}} className={'fas fa-trash'} style={{cursor: "pointer",color: "red"}}></i></td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
        </>
    )
}

export default Trends